export const OFFERSELECTED = 'waitrose/offers/OFFERSELECTED';
